import { InjectionToken } from '@angular/core';
export const ToasterConfigToken = new InjectionToken('ToasterConfigToken');
